import React, {useEffect, useState} from 'react';
import {coursePeriods} from "../../constants";

export function PeriodDay({course, title = false}) {
  const [dateFormatted, setDateFormatted] = useState('');

  useEffect(() => {
    let dateStart = course.start_at;
    let dateEnd = course.finish_at;
    let periodStr = course.period_string;
    if (course.finish_at_part2 && course.finish_at_part2 > dateEnd) {
      dateEnd = course.finish_at_part2;
      periodStr = course.period_string_part2;
    }
    if (course.finish_at_part3 && course.finish_at_part3 > dateEnd) {
      dateEnd = course.finish_at_part3;
      periodStr = course.period_string_part3;
    }

    if (!dateStart && !dateEnd) {
      setDateFormatted((title ? course.product_title + ', ' : '') + periodStr);
      return;
    }
    try {
      const now = new Date();
      now.setHours(0, 0, 0, 0);
      const dt_start = new Date(dateStart);
      dt_start.setHours(0, 0, 0, 0);
      const dt_end = new Date(dateEnd);
      dt_end.setHours(0, 0, 0, 0);
      if (now < dt_start || now > dt_end) {
        setDateFormatted((title ? course.product_title + ', ' : '') + periodStr);
        return;
      }

      let diff = Math.ceil((now.getTime() - dt_start.getTime()) / 1000 / 86400) + 1;
      let passed = 0;
      for (let i = 0; i < coursePeriods.length; i++) {
        if (passed + coursePeriods[i].days >= diff) {
          setDateFormatted(coursePeriods[i].title + (coursePeriods[i].days > 7 ? ', ' + Math.ceil((diff - passed) / 7) + '-я неделя' : ''));
          return;
        }
        passed += coursePeriods[i].days;
      }
      setDateFormatted((title ? course.product_title + ', ' : '') + periodStr);
    } catch (e) {
      console.log('Unable to get day of period ' + dateStart + ' - ' + dateEnd);
      setDateFormatted('');
    }
  }, [course, title]);

  return <React.Fragment>
    {dateFormatted}
  </React.Fragment>;
}
